"use strict";

var NullCache, _cache;

NullCache = {
  getItem: function getItem(key, cb) {
    return cb(null, null);
  },
  setItem: function setItem(key, value, cb) {
    return cb(null, value);
  }
};

_cache = NullCache;

module.exports = {
  getItem: function getItem(key, cb) {
    return _cache.getItem(key, cb);
  },
  setItem: function setItem(key, value, cb) {
    return _cache.setItem(key, value, cb);
  },
  setImpl: function setImpl(cacheImpl) {
    return _cache = cacheImpl;
  }
};